









































































































































import DatePicker from "vue-flatpickr-component";

import { Vue, Component, Lifecycle } from "av-ts";
import { IOffering, IOfferingUser, ITopic, IOfferingSummary } from "../../interfaces/models";

import Fetcher from "../../services/Fetcher";
import UserService from "../../services/UserService";
import TopicService from "../../services/TopicService";
import { serverToLocalFull, serverToLocal, localTZToUTC, isAdmin, addEventsToQueue } from "../../util";

import LeaderBoard from "../leaderboard/LeaderBoard.vue";
import TopicChip from "../util/TopicChip.vue";
import PageLoader from "../util/PageLoader.vue";


import TopicPicker from "./TopicPicker.vue";

const _MODAL_NAME = "course_create_modal";

interface IConstructTopic {
    id?: number,
    name: string;
};

@Component({
    components: {
        DatePicker,
        TopicPicker,
        TopicChip,
        LeaderBoard,
        PageLoader
    }
})
export default class AdminView extends Vue {
    pTopics: ITopic[] = [];
    
    teachingStart: string = "";
    teachingEnd: Date | undefined = undefined;

    pOfferingUser: IOfferingUser | undefined = undefined;
    pCsvString: string = "";
    pOfferingSummary: IOfferingSummary | undefined = undefined;
    networkError: string = "";

    pOfferingID: string = "";
    pCourseCode: string = "";
    pOfferingName: string = "";
    pOfferingSem: string = "";
    pUniversityName: string = "";
    pOfferingAvailable: boolean | undefined = false;
    pUniversities: string[] | undefined = undefined;

    loading = false;

    updateOfferingUser(offeringUser: IOfferingUser) {
        if (!isAdmin(offeringUser.roles)) {
            this.$router.push("error/403");
        }

        this.pOfferingUser = offeringUser;
        this.updateOfferingVars(offeringUser.offering);

        if (this.pOfferingAvailable === false) {
            this.openDialog();
        }
        if (this.pOfferingUser.offering.start) {
            this.teachingStart = serverToLocal(this.pOfferingUser.offering.start);
        } else {
            this.teachingStart = "";
        }
        /*if (this.pCourse.end) {
            this.teachingEnd = serverToLocal(this.pCourse.end);
        }*/
    }

    updateOfferingVars(offering: IOffering) {
        this.pOfferingID = offering.offeringID;
        this.pCourseCode = offering.courseCode;
        this.pOfferingName = offering.offeringName;
        this.pOfferingSem = offering.offeringSem;
        this.pUniversityName = offering.universityName;
        this.pOfferingAvailable = offering.available;
    }

    updateOfferingStats(offeringSummary: IOfferingSummary) {
        this.pOfferingSummary = offeringSummary;
    }

    updateUniversities(universityList: string[]) {
        this.pUniversities = universityList;
    }

    get topics() {
        return this.pTopics;
    }

    get editableTopics() {
        return this.pTopics.map(x => x.name);
    }

    get lastAttemptedFormatted() {
        if (this.pOfferingSummary !== undefined) {
            return serverToLocalFull(this.pOfferingSummary.lastAttempted);
        }
    }

    topicsEdited(newTopics: string[]) {
        this.editableTopics = newTopics;
    }

    set editableTopics(newTopics: (ITopic | string)[]) {
        const normalisedTopics: IConstructTopic[] = newTopics.map(x => {
            if (typeof x === "string") {
                return {
                    id: undefined,
                    name: x
                };
            }
            return x;
        });

        this.pTopics = normalisedTopics.reduce((carry: ITopic[], topic: IConstructTopic) => {
            if (carry.find(x => topic.name.toLowerCase() === x.name.toLowerCase()) === undefined) {
                carry.push(topic as ITopic);
            }
            return carry;
        }, []);
    }

    updateOfferingTopics(topics: ITopic[]) {
        this.pTopics = topics;
    }

    get courseCode() {
        return this.pCourseCode;
    }

    get offeringName() {
        return this.pOfferingName;
    }

    get offeringSem() {
        return this.pOfferingSem;
    }

    get universityName() {
        return this.pUniversityName;
    }

    set courseCode(newCode: string) {
        this.pCourseCode = newCode;
    }

    set offeringName(newName: string) {
        this.pOfferingName = newName;
    }

    set offeringSem(newSem: string) {
        this.pOfferingSem = newSem;
    }

    set universityName(newUni: string) {
        this.pUniversityName = newUni;
    }

    get offeringIsAvailable() {
        return this.pOfferingAvailable;
    }

    get universityList() {
        return this.pUniversities;
    }

    set universityList(newList: string[] | undefined) {
        this.pUniversities = newList;
    }

    @Lifecycle
    mounted() {
        Fetcher.get(UserService.getLoggedInUser)
            .on(this.updateOfferingUser);
        Fetcher.get(TopicService.getAllAvailableTopics)
            .on(this.updateOfferingTopics);
        Fetcher.get(UserService.getCourseStats)
            .on(this.updateOfferingStats);
        Fetcher.get(UserService.getUniversities)
            .on(this.updateUniversities);
    }

    @Lifecycle
    destroyed() {
        Fetcher.get(UserService.getLoggedInUser)
            .off(this.updateOfferingUser);
        Fetcher.get(TopicService.getAllAvailableTopics)
            .off(this.updateOfferingTopics);
        Fetcher.get(UserService.getCourseStats)
            .off(this.updateOfferingStats);
        Fetcher.get(UserService.getUniversities)
            .off(this.updateUniversities);
    }

    openDialog() {
        const modal = this.$refs[_MODAL_NAME] as any;
        if (modal) {
            requestAnimationFrame(() => modal.open());
        }
    };

    closeDialog() {
        (this.$refs[_MODAL_NAME] as any).close();
    }

    saveOfferingInformation(topics: ITopic[]) {
        if (this.pOfferingID == undefined) {
            return;
        }

        UserService.updateOffering({
            offering: {
                offeringID: this.pOfferingID,
                courseCode: this.courseCode,
                offeringName: this.pOfferingName,
                offeringSem: this.pOfferingSem,
                universityName: this.pUniversityName,
                start: new Date(this.teachingStart).getTime()/1000,
                end: localTZToUTC(this.teachingEnd),
                available: true
            },
            topics: topics
        })
        .then((x: any | IOfferingUser) => {
            if (x.error !== undefined) {
                this.networkError = x.error;
            } else {
                addEventsToQueue([{
                    name: "Data Updated",
                    description: "Course Information Updated",
                    icon: "check"
                }]);
                this.updateOfferingUser(x);
                this.closeDialog();
            }
        })
        .then(() => Fetcher.forceUpdate());
    }

    loadingOn() {
        this.loading = true;
    }

    loadingOff() {
        this.loading = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/admin/AdminView.vue